export const createProductList = (
  productListId: number | undefined,
  productListName: string,
  productListItemId: number | undefined,
  productId: string,
  displayName: string
) => {
  return {
    __typename: 'ProductList',
    id: productListId,
    productListName,
    items: [createProductListItem(productListItemId, productId, displayName)],
  }
}

export const createProductListItem = (
  productListItemId: number | undefined,
  productId: string,
  displayName: string
) => {
  return {
    __typename: 'ProductListItem',
    id: productListItemId,
    productErpIdentifier: productId,
    product: {
      displayName,
      id: productId,
      productErpIdentifier: productId,
      __typeName: 'Product',
    },
  }
}
